var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsString, Matches } from 'class-validator';
import { OrderDirection } from '../../../enums/common/order-direction.enum';
/** A property path such as `pickUpAt` or `vehicleModel.name`. Some lists put it into ORDER BY as text. */
export const SORTING_FIELD_PATTERN = /^[A-Za-z_]\w*(\.[A-Za-z_]\w*)*$/;
export class SortingQueryDto {
}
__decorate([
    IsString(),
    Matches(SORTING_FIELD_PATTERN),
    __metadata("design:type", String)
], SortingQueryDto.prototype, "field", void 0);
__decorate([
    IsEnum(OrderDirection),
    __metadata("design:type", String)
], SortingQueryDto.prototype, "order", void 0);
